<template>
  <div class="rss-page page-container pt-3 pb-4">
    <div class="title d-flex align-items-baseline mb-2">
      <h3 class="inline-block">
        {{ $t("title") }}
      </h3>
      <span class="ml-5 text-primary">{{ $t("content") }}</span>
    </div>
    <div class="row">
      <div class="col">
        <div
          class="tab-header title d-flex justify-content-between align-items-center bg-dark-blue"
        >
          <h5 class="mb-0 font-weight-normal text-white">
            {{ $t("heading") }}
          </h5>
        </div>
        <ul class="list-unstyled my-2">
          <li class="py-2 pl-3">
            <a
              href="http://feeds.feedburner.com/ShasIlluminatedRss?format=xml"
              target="_blank"
              class="text-rss"
            >
              <i class="fa fa-rss-square fa-fw color-white"></i>
              {{ $t("heading") }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mt-4" v-if="feeds">
      <div class="col-12 col-sm-6 col-md">
        <div
          class="tab-header bg-dark-blue text-white title d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0 font-weight-normal">{{ $_t("KW:masechtos") }}</h5>
        </div>
        <ul class="list-unstyled my-2">
          <li v-for="item in feeds.masechtot" class="py-2 pl-3">
            <a
              :href="item.rss_link ? item.rss_link : '/feed/' + item.url_key"
              target="_blank"
              class="text-rss"
            >
              <i class="fa fa-rss-square fa-fw color-white"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-sm-6 col-md">
        <div
          class="tab-header bg-dark-blue text-white title d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0 font-weight-normal">
            {{ $_t("KW:hadafBeiyunShiur") }}
          </h5>
        </div>
        <ul class="list-unstyled my-2">
          <li v-for="item in feeds.shas_magidei" class="py-2 pl-3">
            <a
              :href="
                item.rss_link
                  ? item.rss_link
                  : '/feed/magid-shiur/' + item.url_key
              "
              target="_blank"
              class="text-rss"
            >
              <i class="fa fa-rss-square fa-fw color-white"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-sm-6 col-md">
        <div
          class="tab-header bg-dark-blue text-white title d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0 font-weight-normal">
            {{ $_t("KW:allMagideiShiur") }}
          </h5>
        </div>
        <ul class="list-unstyled my-2">
          <li v-for="item in feeds.torah_magidei" class="py-2 pl-3">
            <a
              :href="
                item.rss_link ? item.rss_link : '/feed/speaker/' + item.url_key
              "
              target="_blank"
              class="text-rss"
            >
              <i class="fa fa-rss-square fa-fw color-white"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: function () {
    return { title: this.$_t("pages:rss.meta") };
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "rss",
  },
  data: function () {
    return {
      feeds: {
        masechtot: [],
        shas_magidei: [],
        torah_magidei: [],
        static: null,
      },
      loading: false,
    };
  },
  created: function () {
    this.getData();
  },
  computed: {},
  methods: {
    getData: function () {
      this.loading = true;
      this.$http.get("/api/rss").then((response) => {
        this.feeds = response.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rss-page {
  p {
    margin-bottom: 0;
  }
  .tab-header {
    padding: 10px 10px 10px 20px;
    border-radius: 10px 10px 0px 0px;
  }
  ul li a {
    color: black;
    i {
      color: $dark-blue;
    }
  }
}
</style>